import { forwardRef } from "react";
import { Slot } from "@radix-ui/react-slot";
import { cn } from "@/lib/utils";

const variants = {
  default:
    "bg-pawcare-gradient text-white shadow-pawcare hover:shadow-pawcare-lg hover:scale-[1.02] active:scale-[0.98]",
  outline:
    "border-1.5 border-gray-200 bg-white text-app-text shadow-soft hover:bg-gray-50 hover:shadow-soft-lg",
  ghost: "bg-transparent hover:bg-gray-100 text-app-text",
  danger:
    "border-1.5 border-red-200 bg-red-50/60 text-severity-red hover:bg-red-100",
};

const sizes = {
  default: "px-6 py-4 text-base rounded-[18px]",
  sm: "px-4 py-2.5 text-sm rounded-[14px]",
  lg: "px-8 py-5 text-lg rounded-[20px]",
  icon: "w-10 h-10 rounded-[14px]",
};

const Button = forwardRef(
  (
    {
      className,
      variant = "default",
      size = "default",
      asChild = false,
      ...props
    },
    ref
  ) => {
    const Comp = asChild ? Slot : "button";
    return (
      <Comp
        ref={ref}
        className={cn(
          "inline-flex items-center justify-center gap-2.5 font-black transition-all duration-200 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed outline-none font-sans",
          variants[variant],
          sizes[size],
          className
        )}
        {...props}
      />
    );
  }
);

Button.displayName = "Button";
export { Button };
